import React from 'react';
import CKAutocomplete from '../CKAutocomplete';
import WorkdocStore from '../../../stores/WorkdocStore'
import {connect} from 'react-redux'

class AutoSuggestionRegistrationNo extends React.Component {

  constructor(...args) {
    super(...args);

    this.state = {items:[]}
  }

  componentDidMount() {
    this.loadCarRegistrationNo(this.props.formData)
  }

  loadCarRegistrationNo(search) {
    let items = []
    WorkdocStore.loadVehicleRegistrationNo(search,(result)=>{
        result.data.forEach((item,index)=>{
            items.push({label:item.Name,value:item.Value,vehicle_id:item.vehicle_id})
        })
        this.setState({items:items})
    })
  }

  onFormChange(e) {
    this.loadCarRegistrationNo(e.target.value)
    this.props.onChange(e.target.value)   
  }

  onFormSelect(e) {
    let {items} = this.state
    let key = items.findIndex(x=>x.label===e)
    let item = {label:e,vehicle_id:items[key].vehicle_id}
    this.props.onChange(item)
    // this.props.onChange(e)
  }

  render() {
    const {
      formData
    } = this.props;
    let {items} = this.state
    let value = ''
    if (typeof formData.label!=='undefined')
      value = formData.label
    else
      value = formData
    
    return (
        <div>
            <CKAutocomplete
                top={'-35px'}
                items={items}
                value={value}
                onChange={this.onFormChange.bind(this)}
                onSelect={this.onFormSelect.bind(this)}
            />
        </div>    
    )
  }
}

const mapStateToProps = (state) => ({
  store: state,
});

const _Connect = connect(
    mapStateToProps,
)(AutoSuggestionRegistrationNo);

export default _Connect;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/AutoSuggestionRegistrationNo.js